// Kept apart from useFormAssistant so the auth store can clear it without loading Lens.

// One conversation per form until sign-out, an account switch or the form is published, so closing
// and reopening a draft, or moving between drafts in the builder, picks each conversation back up.
const sessions = new Map();

/** Forgets every conversation. Signing out keeps the SPA alive, so the next user would inherit them. */
export function resetFormAssistantSessions() {
    sessions.clear();
}

/** Forgets one form's conversation, once it is published and Lens can no longer change it. */
export function clearFormAssistantSession(formId) {
    sessions.delete(formId);
}

/** The form's session: its messages as shown, the panel state, and the server's form.assist conversation id. */
export function sessionFor(formId) {
    if (!sessions.has(formId)) sessions.set(formId, { messages: [], collapsed: false, conversationId: null });
    return sessions.get(formId);
}
